// extracted by mini-css-extract-plugin
export default {"container":"ImageLoader_container__tyDa4","flare":"ImageLoader_flare__1Jh+e","animation-image-loader":"ImageLoader_animation-image-loader__L01+2"};